import * as yup from 'yup'
import { mediaSchema } from '@/components/inputs'
import { OTHER_COUNTING_OPTION_OPTION_VALUE } from '../fieldsOptions'

export const schema = yup.object({
  counting_method: yup.string().required(),
  counting_method2: yup.string().when('counting_method', {
    is: OTHER_COUNTING_OPTION_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  notes: yup.string().max(256),
  observed_at: yup.date().required(),
  photos: mediaSchema,
})
